import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import * as serviceWorker from './serviceWorker';
import './i18n'
import SubscribeForm from './components/SubscribeForm';
import SubscribeResult from './components/SubscribeResult';
import { getBaseName } from './Utils';

let routerBasename = getBaseName();

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback="loading">
      <BrowserRouter basename={routerBasename}>
        <Switch>
          <Route path="/campaignForm.jsp" component={SubscribeForm}/>
          <Route path="/campaignFormDo.jsp" component={SubscribeResult}/>
          <Route path="/" exact>
            <Redirect to={{ pathname: "/campaignForm.jsp", search: "lang=EN" }}/>
          </Route>
        </Switch>
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('content')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
